import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const BreakdownByCountry = ({ data, palette }) => {
  const chartRef = useRef(null);

  const customizeSeriesNameTooltip = (arg) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${arg.argumentText}</div>
          <div><span style="font-weight: 600;">${arg.seriesName}</span>: ${arg.valueText} €</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="Top 10 Countries with Buckets"
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={data}
          rotated={true}
          id="countriesChart"
          ref={chartRef}
          palette={palette}
        >
          <Series
            valueField="bucket1"
            argumentField="name"
            name="Bucket1"
            type="bar"
          />
          <Series
            valueField="bucket2"
            argumentField="name"
            name="Bucket2"
            type="bar"
          />
          <ArgumentAxis />
          <ValueAxis />
          <Legend visible={true} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeSeriesNameTooltip}
            format="fixedPoint"
            precision={2}
          />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default BreakdownByCountry;
